import { ISchedule } from './types'

export enum TransferTaskType {
    pickup  = 0,
    dropoff = 1,
}

export interface ITransfer{
    transferId: string,
    scheduleObj: ISchedule,
    
}

export interface ITransferTask{
    transferId: string,
    taskType: TransferTaskType,
    startTime: Date | null,
    customerLocationtimezone: string,
    duration: number | null
}

export interface IVirtualTrip {
    virtualTripId: string,
    startTrip: Date,
    endTrip: Date,
    overridedendTrip: Date,
    actualEndTrip: Date,
    tripPlannerId: string | null,
    isMultiLoaded: boolean,
    statusVT: number,
    transfers: ITransfer[],
    deletedFromTimeLine: boolean
    transferTasks: ITransferTask[]
    isTripMinOverrided :boolean,
    overrideTripEstimateInMin:number
}

export interface ILocalStateUpdateResult{
    isLocalStateChanged: boolean,
    updatedState: IVirtualTrip[],
    changedNames: string
}
